<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { get } from 'lodash'
import { Staff } from '@/plugins/api'
import firebase from 'firebase/app'
import 'firebase/messaging'
import { vapidKey, firebaseConfig } from '@/helpers/firebase.js'
export default {
  async mounted() {
    await this.resetPolicies()
    this.initFirebase()
  },
  computed: {
    ...mapState('auth', ['role', 'user', 'policies']),
    ...mapState('constant', ['allowedNotiRoleTypes'])
  },
  methods: {
    ...mapActions({ checkAuthPolices: 'auth/checkAuthPolices' }),
    ...mapMutations({
      addNotificationRealTime: 'postStaff/addNotificationRealTime'
    }),
    async resetPolicies() {
      const roleId = get(this.user, 'role.id', '')
      if (typeof roleId === 'string' && roleId.length) await this.checkAuthPolices({ roleId: this.user.role.id })
    },
    async initFirebase() {
      if (this.user === null) return
      if (this.allowedNotiRoleTypes.includes(this.role.type))
        Notification.requestPermission().then(permission => {
          if (permission !== 'granted') return
          if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig)
          } else {
            firebase.app()
          }
          const messaging = firebase.messaging()
          messaging
            .getToken({ vapidKey })
            .then(currentToken => {
              let lmsStorage = JSON.parse(localStorage.getItem('lms'))
              const user = get(lmsStorage, 'auth.user')
              if (currentToken && currentToken !== get(user, 'fcmWeb')) {
                Staff.subNotify({ token: currentToken })
                const newData = { ...lmsStorage, auth: { ...lmsStorage.auth, user: { ...user, fcmWeb: currentToken } } }
                localStorage.setItem('lms', JSON.stringify(newData))
              }
            })
            .catch(error => {
              console.log('An error occurred while retrieving token firebase.', error)
            })

          messaging.onMessage(payload => {
            if (payload.notification) {
              this.addNotificationRealTime({
                title: payload.notification.title,
                content: payload.notification.body,
                createdAt: new Date().toISOString(),
                isRead: false
              })
            }
          })
        })
    }
  }
}
</script>
<style>
input {
  margin: 0px 0px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.left-amber-border {
  border-left: 4px solid #0d47a1;
}

.required label::after {
  content: ' *';
  color: red;
}

.v-data-table-header {
  background-color: #f5f5f5;
  border-bottom: none;
}

.content-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #757575;
}

.search-button {
  background: white;
  height: 40px !important;
  color: #0d47a1 !important;
}

.tab-active {
  color: #0d47a1 !important;
  background-color: #ffffff !important;
  border: 1px solid lightgrey;
}

.tab-default {
  color: #000;
  background-color: lightgrey;
}

.full-height {
  height: 100% !important;
}

.full-width {
  width: 100% !important;
}
</style>
